import { render, staticRenderFns } from "./BudgetInput.vue?vue&type=template&id=0983b8dc&"
import script from "./BudgetInput.vue?vue&type=script&lang=js&"
export * from "./BudgetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports